import { CRUD, Status } from '../../../../utils/enums'
import { InputModel } from '../../../../utils/types'

export const initialFilterValues = {
  status: '',
  search: '',
}

export const formatFilterMainDepartments = {
  search: 'search',
  from: 'date_init',
  to: "date_end",
  createYear: "year",
  month: "month",
  areas: "areas_ids",
}

export const useFilterDetail = () => {
  return {
    search: {
      label: 'Buscar departamento',
      name: 'search',
    },
    status: {
      label: 'Estado',
      name: 'status',
    },
  }
}

export const initialValues = {
  name: {
    label: 'general.tags.name',
    translate: true,
    name: 'name',
    validate: {
      required: true,
    },
    rest: {
      type: 'alphaNumeric',
      inputProps: {
        maxLength: 45,
      },
    },
    value: null,
  },
  email: {
    label: 'Correo electrónico',
    name: 'email',
    validate: {
      required: true,
      email: true,
    },
    value: null,
  },
  phone: {
    label: 'general.tags.phone',
    translate: true,
    name: 'phone',
    type: 'phone',
    value: '',
    validate: {
      phone: true,
    },
  },
  users: {
    label: 'general.tags.users',
    translate: true,
    name: 'users',
    type: 'filter-select',
    items: [],
    value: null,
  },
} as { [x: string]: InputModel }

export const initialData = {
  name: null,
  email: null,
  phone: null,
}

export const initialTable = {
  column: [],
  row: [],
}

export const useMenuItems = (styles: any) => [
  {
    value: CRUD.EDIT,
    label: 'Editar departamento',
  },
  {
    value: CRUD.DELETE,
    label: 'Eliminar departamento',
  },
]

export const input = {
  search: {
    label: 'general.search',
    translate: true,
    name: 'search',
    type: 'text',
    value: null,
  },
  from: {
    label: 'general.tags.from',
    translate: true,
    name: 'from',
    type: 'date',
    value: null,
    rest: {
      max: 'to',
    },
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
  to: {
    label: 'general.tags.to',
    translate: true,
    name: 'to',
    type: 'date',
    value: null,
    rest: {
      min: 'from',
    },
    size: {
      xl: 6,
      lg: 6,
      md: 6,
      sm: 6,
      xs: 6,
    },
  },
  areas: {
    label: 'general.tags.area',
    translate: true,
    name: 'area',
    type: 'filter-select',
    items: [],
    value: null,
  },
  users: {
    label: 'general.tags.user',
    translate: true,
    name: 'users',
    type: 'filter-select',
    items: [],
    value: [],
  },
} as { [x: string]: InputModel }

export const accept = ['png', 'jpg', 'jpeg']
